import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  FormPopupSurface,
  FormPopupTitle,
} from '../../components/FormPopup/styles';
import {
  ActionButton,
  Actions,
  Body,
  CancelButton,
  DestructiveButton,
} from './styles';

export const MANAGED_EXERCISE_DELETE_ACTIONS = {
  DELETE: 'DELETE_EXERCISE',
  DETACH: 'DETACH_EXERCISE',
};

const ManagedLessonDelete = ({ exerciseName, onClose, onSelect }) => {
  const { t } = useTranslation();
  const displayedExerciseName = exerciseName || t('ManagedLessonDelete.unnamedExercise');

  const selectAction = (action) => () => {
    onClose();
    onSelect(action);
  };

  return (
    <FormPopupSurface>
      <FormPopupTitle>{t('ManagedLessonDelete.title')}</FormPopupTitle>
      <Body>
        {t('ManagedLessonDelete.body', { exerciseName: displayedExerciseName })}
      </Body>
      <Actions>
        <ActionButton onClick={selectAction(MANAGED_EXERCISE_DELETE_ACTIONS.DETACH)}>
          {t('ManagedLessonDelete.keepExercise')}
        </ActionButton>
        <DestructiveButton onClick={selectAction(MANAGED_EXERCISE_DELETE_ACTIONS.DELETE)}>
          {t('ManagedLessonDelete.deleteExercise')}
        </DestructiveButton>
        <CancelButton cancel onClick={onClose}>
          {t('Actions.Instance.cancel')}
        </CancelButton>
      </Actions>
    </FormPopupSurface>
  );
};

ManagedLessonDelete.propTypes = {
  exerciseName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

ManagedLessonDelete.defaultProps = {
  exerciseName: null,
};

export default ManagedLessonDelete;
